var React = require('react');

function IconDA (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M108 788.7h146c5.5 0 10 4.5 10 10v129H98v-129c0-5.5 4.5-10 10-10zM329.3 678h146c5.5 0 10 4.5 10 10v239.7h-166V688c0-5.5 4.5-10 10-10zm221.4-55.3h146c5.5 0 10 4.5 10 10v295h-166v-295c0-5.5 4.5-10 10-10zm221.3-166h146c5.5 0 10 4.5 10 10v461H762v-461c0-5.5 4.5-10 10-10zm-674 83l274.1-274.1c1.5-1.5 3.8-1.6 5.4-.2l163.2 136 249-221.3-83-83H924c2.2 0 4 1.8 4 4v217.3l-83-83-301.7 274.3c-1.5 1.3-3.7 1.4-5.3.1L374.7 373.7 153.3 595 98 539.7z"}));
}

IconDA.displayName = "IconDA";

IconDA.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconDA;

IconDA.default = IconDA;
